import {take, put, call} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as savrActionTypes from '../savrActionTypes';
import sendAttachmentsWithAssignmentFlow from '../../service-cases/sagas/sendAttachmentsWithAssignmentFlow';

/**
 * Update SAVR cost coverage flow
 */
const updateSAVRCostCoverageFlow = function* updateSAVRCostCoverageFlow() {
    while (true) {
        const {payload} = yield take(savrActionTypes.SUBMIT_SAVR_COST_COVERAGE_FORM);
        const {serviceAssignmentLineNo, serviceAssignmentData, attachmentsToSendWithAssignment} = payload;
        const {serviceCaseType, serviceCaseId, serviceCaseData} = payload;

        yield call(sendAttachmentsWithAssignmentFlow, {
            caller: savrActionTypes.SUBMIT_SAVR_COST_COVERAGE_FORM,
            attachmentsToSendWithAssignment,
            serviceCaseId,
        });

        yield* updateServiceCase({
            caller: savrActionTypes.SUBMIT_SAVR_COST_COVERAGE_FORM,
            caseType: serviceCaseType,
            serviceCaseId,
            serviceCaseData,
        });

        yield* updateServiceAssignment({
            caller: savrActionTypes.SUBMIT_SAVR_COST_COVERAGE_FORM,
            assignmentType: efServiceAssignmentTypes.VEHICLE_RETURN,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: savrActionTypes.SUBMIT_SAVR_COST_COVERAGE_FORM},
        });
    }
};

export default updateSAVRCostCoverageFlow;
